import type { TrainTranslations } from "./trainTranslations.types";

const trainFrTranslations: TrainTranslations = {
    trainPage: {
        title: "Train",
        step: "Étape",
        resultsFound: "options de train trouvées",
        stopOver: "Correspondance",
        stopOverPlural: "Correspondances",
        nextStep: "Étape suivante",
        loadingTimeline: "Chargement des horaires…",
    },
    widgetBreadcrumbs: {
        home: "Accueil",
        summary: "Récapitulatif",
        contact: "Coordonnées",
        payment: "Paiement",
    },
    trainSortBy: {
        title: "Trier par",
        price_asc: "Prix le plus bas d'abord",
        price_desc: "Prix le plus élevé d'abord",
        fastest: "Le plus rapide",
        fewest_changes: "Le moins de correspondances"
    },
    trainBlock: {
        title: "Service de train",
        direct: "Direct",

    },
    trainFilters: {
        outboundTrip: {
            title: "Horaires trains aller",
            duration: "Durée",
            departure: {
                location: "",
                time: "Départ"
            },
            arrival: {
                location: "Gare d'arrivée",
                time: "Arrivée"
            }
        },
        inboundTrip: {
            title: "Horaires trains retour",
            duration: "Durée",
            departure: {
                location: "",
                time: "Départ"
            },
            arrival: {
                location: "",
                time: "Arrivée"
            }
        },
        operators: "Opérateur",
        duration: "Durée du trajet"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime-la-Plagne",
        XBM: "Bourg-Saint-Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moûtiers",
        XDB: "Lille",
        PLY: "Paris - Gare de Lyon",
        PAZ: "Paris Gare d’Austerlitz",
        PEST: "Paris - Gare de l'Est",
        PARIS: "Paris - Gare de Lyon",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Anvers",
        BRU: "Bruxelles Midi",
        "Bourg-Saint-Maurice": "Gare de Bourg-Saint-Maurice",
        "Aime-la-Plagne": "Gare de Aime-la-Plagne",
        "Moûtiers": "Gare de Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        SNCF: "SNCF",
        TNE: "Travelski Night Express",
        PEG: "Travelski Night Express",
        PEGASUS: "Travelski Night Express",
    },
    trainClass: {
        standard: "Standard",
        premium: "Première",
        title: "Classes de train",
        outOfStock: "Indisponible"
    },
    trainClassCard: {
        yourTrain: "Votre train",
        travelClass: "Votre classe de voyage",
        details: "Détails",
        from: "A partir de",
        included: "Inclus",
        select: "Selectionner",
        classes: {
            seat: {
                title: "Places assises",
                description: "Place assise parfaite pour un séjour à prix réduit (sièges non inclinables).",
            },
            standard: {
                title: "Standard",
                description: "Couchette standard avec l'essentiel pour le voyage",
            },
            standardPlus: {
                title: "Standard plus",
                description: "Couchette standard avec l'essentiel pour le voyage",
            },
            premiere: {
                title: "Première",
                description: "L'option de voyage premium pour les voyageurs en quête de confort",
            },
        },
        criteria: {
            compartment6: "Compartiment 6 places",
            compartment4: "Compartiment 4 places",
            compartment3: "Compartiment 3 places",
            nonRecliningSeats: "Sièges non inclinables",
            electricalOutlet: "Prise électrique",
            breakfastOptional: "Petit déjeuner en option",
            sleepingBagSheet: "Drap sac de couchage, taie d'oreiller et couverture fournis",
            storageSpace: "Espace de rangement",
            comfortMattress: "Surmatelas confortable",
            sheetDuvetPillow: "Drap, couette et taie d'oreiller fournis",
            storageNet: "Filet de rangement",
            blackoutBlind: "Store occultant",
            realBeds: "Vrais lits, équipés de drap, couette et taie d'oreiller.",
            premiumBedding: "Literie premium",
            loungeSeats3: "3 sièges",
            connectingCompartments: "Compartiments communicants disponibles",
            privateSink: "Lavabo privé",
            largeStorage: "Grand espace de rangement",
            welcomeKit: "Kit de Bienvenue",
        },
        subOptions: {
            individualBerths: {
                title: "{count} couchette individuelle",
                title_plural: "{count} couchettes individuelles",
                description: "Vivez une expérience unique en voyage dans une cabine partagée de 6 places.",
            },
            privateCompartment: {
                title: "Compartiment privé 6 places",
                description: "Réservez l'intégralité d'un compartiment, seul ou à plusieurs, pour votre voyage en famille ou entre amis",
            },
        privateCompartmentStandardPlus: {
            title: "Compartiment privé 6 places",
            description: "Réservez l'intégralité d'un compartiment, seul ou à plusieurs, pour votre voyage en famille ou entre amis",
        },
        privateCompartmentStandardPlus4: {
            title: "Compartiment privé 4 places",
            description: "Réservez l'intégralité d'un compartiment, seul ou à plusieurs, pour votre voyage en famille ou entre amis",
        },
            privateCompartmentPremiere: {
                title: "Compartiment privé 3 places",
                description: "Réservez l'intégralité d'un compartiment, seul ou à plusieurs, pour votre voyage en famille ou entre amis.",
            },
            seat: {
                title: "Places assises",
                description: "Place assise parfaite pour un séjour à prix réduit (sièges non inclinables).",
            },
        },
        modal: {
            serviceTitle: "Service",
            services: {
                seat: {
                    breakfastOptional: "Petit déjeuner en option",
                },
                standard: {
                    breakfastOptional: "Petit déjeuner en option",
                },
                standardPlus: {
                    breakfastOptional: "Petit déjeuner en option",
                    comfortKit: "Kits confort : surmatelas + couette (5,5€/pers)",
                },
                premiere: {
                    breakfastOptional: "Petit-déjeuner en option",
                },
            },
        },
    }
};

export default trainFrTranslations;
